import { render, staticRenderFns } from "./AccountVerificationProvider.vue?vue&type=template&id=195ac278&"
import script from "./AccountVerificationProvider.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports